import styled from 'styled-components';
import ListItem from '@material-ui/core/ListItem';

export const NavItemSubmenu = styled(ListItem)`
  ${(props) => `
    min-height: 48px;
    &.active {
      background-color: ${props.theme.palette.primary.main};
      color: ${props.theme.palette.secondary.contrastText + '!important'};
      pointer-events: none;
      & .list-item-text-primary {
        color: inherit;
      }
      & .list-item-icon {
        color: inherit;
      }
    }
    & .list-item-text {
      padding: 0 0 0 16px;
    }
    color: ${props.theme.palette.text.primary};
    text-decoration: none !important;
    &.dense {
      padding: 8px 12px 8px 12px;
      min-height: 40px;
      & .list-item-text {
        padding: 0 0 0 8px;
      }
    }
  `}
`;
